import request from "@/utils/request";
import axios from "axios";
const cancelToken = axios.CancelToken; //创建取消令牌
let cancel;

// 创建助手
export const createAssistant = data =>
  request({
    url: `/api/v1/chat/assistant/submit`,
    method: "POST",
    data,
    isGptApi: true
  });

// 助手列表
export const assistantList = data =>
  request({
    url: `/api/v1/chat/assistant/list`,
    method: "GET",
    data,
    isGptApi: true
  });

// 助手详情
export const assistantDetail = data =>
  request({
    url: `/api/v1/chat/assistant/detail/${data.id}`,
    method: "GET",
    data,
    isGptApi: true
  });

// 表单备选值里的选项 根据id查询指定数据源sourcetype
export const getDataBySource = data =>
  request({
    url: `/api/v1/chat/assistant/datasource/${data.sourceTypeId}?keywords=${data.keywords}`,
    method: "POST",
    data,
    isGptApi: true
  });

// 指定数据源类型
export const assistantDatasource = data =>
  request({
    url: `/api/v1/chat/assistant/datasource`,
    method: "POST",
    data,
    isGptApi: true
  });

// 删除助手
export const deleteAssistant = id =>
  request({
    url: `/api/v1/chat/assistant/del/${id}`,
    method: "POST",
    isGptApi: true
  });

// 发布助手
export const publishAssistant = data =>
  request({
    url: `/api/v1/chat/assistant/publish`,
    method: "POST",
    data,
    isGptApi: true
  });

// 获取站点
export const getChatSites = () =>
  request({
    url: `/api/v1/public/chat/sites`,
    method: "get",
    isGptApi: true
  });

// 查询历史聊天记录
export const getAssistantLogList = data =>
  request({
    url: `/api/v1/chat/assistant/log/${data.toolId}/list`,
    method: "get",
    data,
    isGptApi: true
  });

// 知识库列表
export const knowledgeList = data =>
  request({
    url: `/api/v1/chat/Knowledge/knowledge/list`,
    method: "POST",
    data,
    isGptApi: true
  });

// 新增(编辑)知识库
export const addKnowledge = data =>
  request({
    url: `/api/v1/chat/Knowledge/config`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 删除知识库
export const deleteKnowledge = id =>
  request({
    url: `/api/v1/chat/Knowledge/knowledge/del/${id}`,
    method: "POST",
    isGptApi: true
  });

// 数据集详情
export const dataSetDetail = id =>
  request({
    url: `/api/v1/chat/Knowledge/data/set/detail/${id}`,
    method: "POST",
    isGptApi: true
  });

// 知识点列表
export const knowledgePointList = data =>
  request({
    url: `/api/v1/chat/Knowledge/point/list`,
    method: "POST",
    data,
    isGptApi: true
  });

// 编辑知识点
export const editKnowledgePoint = data =>
  request({
    url: `/api/v1/chat/Knowledge/edit/point`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 删除知识点
export const deleteKnowledgePoint = id =>
  request({
    url: `/api/v1/chat/Knowledge/del/point/${id}`,
    method: "POST",
    isGptApi: true
  });

// 手动导入数据集
export const knowledgeImport = data =>
  request({
    url: `/api/v1/chat/Knowledge/handle/import`,
    method: "POST",
    data,
    isGptApi: true
  });

// 文档/网页导入内容提交
export const importAnalysisSubmit = data =>
  request({
    url: `/api/v1/chat/Knowledge/analysis/submit`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 文档上传解析
export const importFileAnalysis = data =>
  request({
    url: `/api/v1/chat/Knowledge/file/import/analysis`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true,
    cancelToken: new cancelToken(function executor(c) {
      // 将创建的取消令牌放入请求配置中
      cancel = c;
    })
  });

// 网页上传解析
export const importWebAnalysis = data =>
  request({
    url: `/api/v1/chat/Knowledge/web/analysis`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true,
    cancelToken: new cancelToken(function executor(c) {
      // 将创建的取消令牌放入请求配置中
      cancel = c;
    })
  });

// 停止上传解析
export const cancelRequest = () => {
  if (cancel) {
    cancel("取消请求");
  }
};

// 对话明细列表
export const getAssistantLogDetail = data =>
  request({
    url: `/api/v1/chat/assistant/log/page`,
    method: "POST",
    data,
    isGptApi: true
  });

// 知识库列表(助手下)
export const getAssistantKnowledge = data =>
  request({
    url: `/api/v1/chat/Knowledge/assistant/knowledge/list`,
    method: "POST",
    data,
    isGptApi: true
  });

// 知识库状态修改(助手下)
export const statusAssistantKnowledge = data =>
  request({
    url: `/api/v1/chat/Knowledge/assistant/knowledge/status`,
    method: "POST",
    data,
    isGptApi: true
  });

// 知识库添加(助手下)
export const addAssistantKnowledge = data =>
  request({
    url: `/api/v1/chat/Knowledge/assistant/knowledge/add`,
    method: "POST",
    data,
    isGptApi: true
  });

// 知识库状态修改(助手下)
export const delAssistantKnowledge = id =>
  request({
    url: `/api/v1/chat/Knowledge/assistant/knowledge/del/${id}`,
    method: "POST",
    isGptApi: true
  });

// 知识库-数据集列表
export const getKnowledgeDataSetsList = data =>
  request({
    url: `/api/v1/chat/Knowledge/data/set/list`,
    method: "POST",
    isGptApi: true,
    data
  });

// 知识库-数据集统计
export const getKnowledgeDataSetsCount = data =>
  request({
    url: `/api/v1/chat/Knowledge/data/set/list/count`,
    method: "POST",
    isGptApi: true,
    data
  });

//知识库-数据集删除
export const delKnowledgeDataSets = id =>
  request({
    url: `/api/v1/chat/Knowledge/data/set/del/${id}`,
    method: "POST",
    isGptApi: true
  });

// 查看助手上下文
export const getAssistantLogContext = data =>
  request({
    url: `api/v1/chat/assistant/log/context`,
    method: "POST",
    data,
    isGptApi: true
  });

// 批量导入数据集
export const knowledgeBatchImport = data =>
  request({
    url: `/api/v1/chat/Knowledge/batch/import`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 批量导入数据集进度查询
export const knowledgeBatchImportProgress = id =>
  request({
    url: `/api/v1/chat/Knowledge/batch/import/progress/${id}`,
    method: "POST",
    showLoading: false,
    isGptApi: true
  });

// 停止批量导入数据集
export const knowledgeBatchImportStop = id =>
  request({
    url: `/api/v1/chat/Knowledge/stop/batch/import/${id}`,
    method: "POST",
    isGptApi: true
  });

// 获取知识库详情
export const getKnowledgeDetail = id =>
  request({
    url: `/api/v1/chat/Knowledge/knowledge/detail/${id}`,
    method: "POST",
    showLoading: false,
    isGptApi: true
  });

// 获取函数列表
export const getFunctionList = () =>
  request({
    url: `/api/v1/chat/function/list`,
    method: "GET",
    showLoading: false,
    isGptApi: true
  });

// token费用预估
export const knowledgeFeeExcept = data =>
  request({
    url: `/api/v1/chat/Knowledge/fee/expect`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 用量监测
export const assistantLogStatistics = data =>
  request({
    url: `/api/v1/chat/assistant/log/statistics`,
    method: "GET",
    data,
    isGptApi: true
  });

// 查看助手的引用文档
export const assistantRefrenceDoc = data =>
  request({
    url: `/api/v1/chat/assistant/log/refrence/doc`,
    method: "POST",
    data,
    isGptApi: true
  });

// 用量概览
export const assistantLogStatisticsSummary = params =>
  request({
    url: `/api/v1/chat/assistant/log/statistics/summary`,
    method: "POST",
    params,
    isGptApi: true
  });

// 对话明细生成知识点
export const knowledgeDialogueCreate = data =>
  request({
    url: `/api/v1/chat/Knowledge/dialogue/create`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 数据集文本编辑
export const editDataSetText = data =>
  request({
    url: `/api/v1/chat/Knowledge/handle/edit`,
    method: "POST",
    data,
    showLoading: false,
    isGptApi: true
  });

// 搜索测试 score相关度
export const searchKnowledgeVector = params =>
  request({
    url: `/api/v1/chat/Knowledge/vector/search/${params.knowledgeId}`,
    method: "POST",
    params,
    isGptApi: true
  });

//搜索测试 score相关度搜索记录
export const searchKnowledgeVectorHistory = params =>
  request({
    url: `/api/v1/chat/Knowledge/vector/search/${params.knowledgeId}/history`,
    method: "GET",
    params,
    showLoading: false,
    isGptApi: true
  });
